
import React from 'react';

const Step: React.FC<{ id: string; num: string; title: string; desc: string }> = ({ id, num, title, desc }) => (
  <div className="relative flex gap-10 items-start group cursor-default">
    <div className="absolute top-10 bottom-0 left-8 w-px bg-white/5 group-last:hidden"></div>
    
    <div className="flex-shrink-0 w-16 h-16 rounded-2xl glass-card border border-white/10 flex items-center justify-center text-[#32dee6] font-bold text-xl transition-all duration-500 group-hover:bg-[#32dee6] group-hover:text-black group-hover:border-[#32dee6] relative z-10">
      {num}
    </div>
    <div className="pb-20 space-y-4 transition-all duration-500 group-hover:translate-x-4">
      <div className="mono text-[10px] text-gray-600 font-bold uppercase tracking-[0.3em]">BLUEPRINT_STEP_{id}</div>
      <h4 className="text-3xl font-bold text-white tracking-tight">{title}</h4>
      <p className="text-gray-400 text-lg leading-relaxed max-w-xl">{desc}</p>
    </div>
  </div>
);

const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="py-40 px-6 bg-[#050505] relative border-y border-white/5">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-2 gap-32">
          <div className="space-y-12">
            <div className="space-y-4">
              <div className="mono text-[10px] font-bold text-[#32dee6] tracking-[0.4em] uppercase">Implementation_Logic</div>
              <h2 className="text-6xl md:text-8xl font-extrabold text-white tracking-tighter">THE STEPS.</h2>
            </div>
            
            <div className="pt-12">
              <Step id="01" num="01" title="Build & Deploy" desc="Your AI Receptionist is live in under 48 hours, fully scripted via LaunchScript AI to match your specific industry tone." />
              <Step id="02" num="02" title="SMS Integration" desc="Installation of the FrontDesk SMS bridge for instant, human-like follow-up sequences that rescue lost inquiries." />
              <Step id="03" num="03" title="Activate Coverage" desc="24/7 system activation for nights and weekends, handing you back your time while maintaining a predictable pipeline." />
            </div>
          </div>
          
          <div className="relative sticky top-40 h-fit">
            <div className="aspect-square bg-white/[0.02] rounded-[5rem] border border-white/5 flex items-center justify-center p-16">
               <div className="relative w-full h-full bg-[#0a0a0a] rounded-[3rem] shadow-2xl overflow-hidden border border-white/10 group">
                 <div className="absolute inset-0 grid-pattern opacity-10"></div>
                 
                 <div className="p-8 border-b border-white/5 flex justify-between items-center relative z-10">
                   <div className="flex space-x-2">
                     <div className="w-2.5 h-2.5 rounded-full bg-white/10"></div>
                     <div className="w-2.5 h-2.5 rounded-full bg-white/10"></div>
                     <div className="w-2.5 h-2.5 rounded-full bg-[#32dee6] dot-pulse"></div>
                   </div>
                   <div className="mono text-[9px] text-gray-500 font-bold tracking-widest">DEPLOY_SYNC::LIVE</div>
                 </div>

                 <div className="p-10 space-y-10 relative z-10">
                   <div className="grid grid-cols-2 gap-8">
                     <div className="glass-card rounded-2xl p-6 border border-white/5">
                        <div className="mono text-[8px] text-gray-600 mb-2">DEPLOY_SPEED</div>
                        <div className="text-3xl font-black text-white">&lt;48H</div>
                     </div>
                     <div className="glass-card rounded-2xl p-6 border border-[#32dee6]/20">
                        <div className="mono text-[8px] text-[#32dee6] mb-2">TOUCHPOINTS</div>
                        <div className="text-3xl font-black text-[#32dee6]">8/48h</div>
                     </div>
                   </div>

                   <div className="space-y-6">
                     {['AI_Receptionist', 'SMS_System', '24_7_Coverage'].map((pillar, i) => (
                       <div key={i} className="flex items-center space-x-6">
                         <div className="w-2 h-2 rounded-full bg-[#32dee6] shadow-[0_0_8px_#32dee6]"></div>
                         <div className="flex-1 h-px bg-white/5"></div>
                         <div className="mono text-[9px] text-gray-400">{pillar}::ACTIVE</div>
                       </div>
                     ))}
                   </div>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
